import { render, staticRenderFns } from "./DirectDebitDetailPage.vue?vue&type=template&id=161ce3c0&scoped=true&"
import script from "./DirectDebitDetailPage.vue?vue&type=script&lang=js&"
export * from "./DirectDebitDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DirectDebitDetailPage.vue?vue&type=style&index=0&id=161ce3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ce3c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161ce3c0')) {
      api.createRecord('161ce3c0', component.options)
    } else {
      api.reload('161ce3c0', component.options)
    }
    module.hot.accept("./DirectDebitDetailPage.vue?vue&type=template&id=161ce3c0&scoped=true&", function () {
      api.rerender('161ce3c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/DirectDebitDetailPage.vue"
export default component.exports